/**
 * Auto-generated by codegen-v2. Do not edit by hand.
 *
 * Maps each OpenAPI schema to an ordered list of field names suitable
 * for rendering as a human-readable label of that DTO.
 */
export const entityDisplayKeys: Record<string, string[]> = {
  FetchSupplierResponse: ['name'],
  FetchAddressResponse: ['street', 'city'],
  FetchOrganisationResponse: ['name', 'vat_number'],
  FetchOrganisationContactPersonResponse: ['first_name', 'last_name'],
  FetchAssigneeResponse: ['name', 'function'],
  FetchTicketContactPersonResponse: ['first_name', 'last_name', 'phone_number'],
  FetchSiteResponse: ['name', 'street'],
  FetchTicketResponse: ['title', 'description'],
  FetchUserResponse: ['first_name', 'last_name'],
  FetchCategoryResponse: ['name'],
  FetchServiceHistoryResponse: ['type'],
  FetchUnitResponse: ['name', 'manufacture_name'],
  FetchServicePropertyAttributeResponse: ['name', 'data_type'],
  NestedContactDetailResponse: ['phone_number', 'mobile_phone_number'],
  NestedOrganisationContactPerson: ['first_name', 'last_name'],
  NestedAddressResponse: ['street', 'city'],
  NestedAddressWithContacDetailResponse: ['street', 'city'],
  NestedOrganisationFileResponse: ['name', 'type'],
  NestedOrganisationResponse: ['name'],
  NestedUserResponse: ['first_name', 'last_name'],
  NestedTicketResponse: ['type', 'title'],
  NestedTicketStatus: ['name', 'label', 'business_identifier'],
  NestedTicketStatusDetail: ['name', 'business_identifier'],
  NestedAssignmentResponse2: ['status', 'type', 'action_type'],
  NestedCommentResponse: ['access_level'],
  NestedTicketArticleResponse: ['brand_name', 'name', 'code'],
  NestedTicketContactPerson: ['first_name', 'last_name', 'phone_number'],
  NestedFileResponse: ['type'],
  NestedCaseDetail: ['name', 'business_identifier'],
  NestedUserAssigneeResponse: ['name', 'function'],
  NestedPropertyResponse: ['value'],
  NestedPropertyAttributeResponse: ['name'],
  NestedUnitResponse: ['name'],
  NestedServicePropertyResponse: ['value'],
  NestedCategoryResponse: ['name'],
  NestedUnitServicePropertyResponse: ['value'],
  NestedServiceHistoryResponse: ['type'],
  NestedContractResponse: ['type', 'description'],
  NestedPropertyAttributeResponse2: ['name'],
}
